import { apiRequest } from "util/services";
import {
  mountEmbeddedCheckout,
  redirectToStripeCheckout,
} from "util/stripeCheckout";

export const ALERT_PAYMENT_REQUIRED = "ALERT_PAYMENT_REQUIRED";
export const ALERT_LIMIT_REACHED = "ALERT_LIMIT_REACHED";
export const KPI_PAYMENT_REQUIRED = "KPI_PAYMENT_REQUIRED";
export const KPI_ORG_LIMIT_REACHED = "KPI_ORG_LIMIT_REACHED";

/** @deprecated use fetchOrgQuota */
export async function fetchAlertLimits() {
  return fetchOrgQuota();
}

export async function fetchOrgQuota() {
  const res = await apiRequest("notice/alerts/limits", "POST", {}, true);
  if (res?.success) {
    return res.success;
  }
  return null;
}

export async function createAlertPackCheckoutSession(
  returnPath = "/console/alerts",
  checkoutUi = "embedded",
) {
  const origin = window.location.origin;
  const path = returnPath.startsWith("/") ? returnPath : `/${returnPath}`;
  return apiRequest(
    "subscriptions/alerts/stripe/checkout",
    "POST",
    {
      success_url: `${origin}${path}?alert_purchase=success`,
      cancel_url: `${origin}${path}?alert_purchase=cancelled`,
      checkout_ui: checkoutUi,
    },
    true,
  );
}

export async function mountAlertPackEmbeddedCheckout(container, sessionPayload) {
  const {
    publishable_key: publishableKey,
    client_secret: clientSecret,
    checkout_url: checkoutUrl,
    session_id: sessionId,
    checkout_ui: mode,
  } = sessionPayload;

  if (mode === "embedded" && clientSecret && publishableKey && container) {
    const checkout = await mountEmbeddedCheckout({
      publishableKey,
      clientSecret,
      container,
    });
    return { mode: "embedded", checkout };
  }

  await redirectToStripeCheckout({
    publishableKey,
    sessionId,
    checkoutUrl,
  });
  return { mode: "redirect" };
}

export function isAlertPaymentRequired(response) {
  return response?.error_code === ALERT_PAYMENT_REQUIRED;
}

export function isAlertLimitReached(response) {
  return response?.error_code === ALERT_LIMIT_REACHED;
}

export function shouldOpenAlertUpgrade(response) {
  return isAlertPaymentRequired(response);
}

export function isKpiPaymentRequired(response) {
  return response?.error_code === KPI_PAYMENT_REQUIRED;
}

export function shouldOpenOrgAddonUpgrade(response) {
  return isAlertPaymentRequired(response) || isKpiPaymentRequired(response);
}
